module.exports = __webpack_public_path__ + "img/icon.35e3e617.svg";